export default __webpack_public_path__ + "static/cornerstone-67e1399889fb6f7d261a47ae2aa42f8a.png";